import { indexItemsById } from '@/helpers/IndexHelpers';
import { API } from '@/api/API';
import { apiEntities } from '@/api/Helpers';
export function getMembershipRules(query) {
    return API.getCached('membership_rules', {
        embed: 'ticket_type',
        limit: 1000,
        query,
    }).then((response) => {
        const entities = apiEntities(response);
        return {
            rules: entities.membership_rules,
            ticketTypes: entities.ticket_type,
            indexedTypes: indexItemsById(entities.ticket_type),
        };
    });
}
